// src/Firebase/firebase7.ts (Oyun 7)
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyA11mwLYAMf7S4MzzJ3BY3AUfm7t_dF1Tc",
  authDomain: "echoes-of-self.firebaseapp.com",
  projectId: "echoes-of-self",
  storageBucket: "echoes-of-self.firebasestorage.app",
  messagingSenderId: "697052261419",
  appId: "1:697052261419:web:ee069b5c4d1f211d11ce6e",
  measurementId: "G-TR4TQQF61E"
};

const app = initializeApp(firebaseConfig, "echoes-of-self");
export const db7 = getFirestore(app);
export const analytics = getAnalytics(app); 